// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2xXyP","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2Bysh","obliqueLine":"membershipbadge_obliqueLine__1SWM6"};